import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { AboutPage } from './pages/AboutPage';
import { BusinessDetailPage } from './pages/BusinessDetailPage';
import { Navbar } from './components/Navbar';
export type Page = 'home' | 'about' | 'business';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [currentSlug, setCurrentSlug] = useState<string>('');
  const handleNavigate = (page: Page, slug?: string) => {
    setCurrentPage(page);
    if (slug) setCurrentSlug(slug);
    window.scrollTo(0, 0);
  };
  return <>
      <Navbar currentPage={currentPage === 'business' ? 'home' : currentPage} onNavigate={page => handleNavigate(page)} data-id="element-0" />

      {currentPage === 'home' && <LandingPage onNavigate={handleNavigate} data-id="element-1" />}
      {currentPage === 'about' && <AboutPage data-id="element-2" />}
      {currentPage === 'business' && <BusinessDetailPage slug={currentSlug} onNavigate={handleNavigate} data-id="element-3" />}
    </>;
}